import ProductCard from '@/molecules/ProductCard'
import Product from '@/ts/Product'

import css from './scss/index.module.scss'

function ProductsGrid({ products, asFeatured = false }: ProductsGridProps) {
  return (
    <div className={css['products-grid']}>
      {products?.map((product) => (
        <article key={product.id}>
          <ProductCard product={product} asFeatured={asFeatured} />
        </article>
      ))}
    </div>
  )
}

export interface ProductsGridProps {
  products: Product[]
  asFeatured?: boolean
}

export default ProductsGrid
